import React from "react";

import { DatePicker } from "antd";
import moment from "moment";
import styled from "styled-components";

import {
  midstreamNavigatorActions,
  useMidstreamNavigatorContext
} from "../context/MidstreamNavigatorContext";

const MonthSelectorButton: React.FC = () => {
  const [state, dispatch] = useMidstreamNavigatorContext();

  const handleMonthChange = (date: moment.Moment | null) => {
    if (!date) {
      dispatch(midstreamNavigatorActions.setSelectedMonth(null));
      return;
    }
    const dateString = date.format("YYYY-MM-DD");
    dispatch(midstreamNavigatorActions.setSelectedMonth(dateString));
  };

  return (
    <Container>
      <label>Month</label>
      <DatePicker
        picker="month"
        value={state.selectedMonth ? moment(state.selectedMonth) : undefined}
        onChange={handleMonthChange}
        data-testid="month-selector-button"
        style={{ width: "100%", borderRadius: "6px" }}
      />
    </Container>
  );
};

export default MonthSelectorButton;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  flex-direction: column;
  cursor: default;
  flex-grow: 1;

  .ant-picker:hover {
    border-color: var(--color-primary);
  }

  .ant-picker-focused {
    border-color: var(--color-primary-hover) !important;
    box-shadow: 0 0 0 2px rgba(var(--color-primary-rgb), 0.3);
  }
`;
